module.exports = __webpack_public_path__ + "img/Casi.ebcf457a.jpeg";